<template>
    <v-dialog v-model="show" width="500" class="clipper-dialog">
        <div class="photo_clipper">
            <button class="close_modal" @click="$emit('close')">
                <span class="close-icon"></span>
            </button>
            <clipper-fixed
                preview="avatarPreview"
                ref="clipper"
                :ratio="240/269"
                class="basic lg clipper-fixed"
                :src="image"
                bg-color="transparent"
                :round="false"
                :grid="false"
                shadow="rgba(0,0,0,0.8)"
                :area="50"
                :handle-zoom-event="handleZoom"
                @load="imgLoad"
                :rotate="0">
                <div slot="placeholder">No image</div>
            </clipper-fixed>

            <div class="slider-container">
                <span class="zoom-label small">−</span>
                <clipper-range v-model="scale" :min="0.5" :max="2" class="modern-range" stop-position-mouse></clipper-range>
                <span class="zoom-label large">+</span>
            </div>

            <div class="actions_clipper_photo">
                <button type="button" class="close_clipper_photo" @click="$emit('close')" v-ripple>Cancel</button>
                <button type="button" class="clip_photo primary_btn" @click="clipImage" v-ripple>Apply</button>
            </div>
        </div>
    </v-dialog>
</template>

<script>
export default {
    name: "PhotoClipper",
    props: {
        show: {
            type: Boolean,
            required: true
        },
        image: {
            type: String,
            required: true
        }
    },
    data() {
        return {
            scale: 0.5
        }
    },
    watch: {
        scale(val) {
            this.$refs.clipper.setWH$.next(+val);
        }
    },
    methods: {
        handleZoom(scale) {
            if (!isNaN(scale)) {
                const limitedScale = Math.max(Math.min(2, scale), 0.1);
                this.scale = limitedScale;
                return limitedScale;
            }
        },
        imgLoad() {
            this.scale = 0.5;
            this.$refs.clipper.setWH$.next(0.5);
        },
        clipImage() {
            const canvas = this.$refs.clipper.clip();
            const dataURL = canvas.toDataURL("image/png", 1);
            const newCacheKey = new Date().getTime();
            
            // Emit events in a specific order
            this.$emit('save', dataURL);
            this.$emit('update-cache-key', newCacheKey);
            this.$emit('image-updated', dataURL);
            this.$emit('close');
        }
    }
}
</script>

<style lang="scss">
/* Import shared clipper styles */
@import "@/assets/scss/components/clipper-styles.scss";

/* Component-specific overrides and adjustments */
.photo_clipper .clipper-fixed.basic {
  aspect-ratio: 240/269;
}

/* Special zoom label styling unique to PhotoClipper */
.slider-container {
  .zoom-label {
    width: 20px;
    height: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    font-weight: bold;
    color: rgba(255, 255, 255, 0.7);
    user-select: none;
    line-height: 1;
    
    &.small {
      font-size: 24px;
    }
    
    &.large {
      font-size: 20px;
    }
  }
}
</style>
